<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow title="Modifier une hospitalisation"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b-form @submit.stop.prevent="onSubmit">

          <b-row>
            <b-col>
              <b-form-group
                id="animal-input"
                label="Animal"
                label-for="animal-input"
                class="bold-label"
                :invalid-feedback="form.animal.invalidFeedback"
                :state="form.animal.state"
              >
                <AutoCompleteInput
                  id="animal-select"
                  placeholder="Sélectionner un animal"
                  :options="animals"
                  :initValue="form.animal"
                  @didSelect="(value) => form.animal.value = value"
                  @onReset="animalSelectInvalid = false"
                  :invalid="animalSelectInvalid"
                  invalid-message="Vous devez sélectionner un animal"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="goal-input"
                label="Motif"
                label-for="goal-input"
                class="bold-label"
                :invalid-feedback="form.goal.invalidFeedback"
                :state="form.goal.state"
              >
                <b-form-input
                  id="goal-input"
                  v-model="form.goal.value"
                  type="text"
                  maxlength="250"
                  :state="form.goal.state"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Date de début *"
                label-for="startDateCal"
                class="bold-label"
                :description="'Format : ' + new Date().toLocaleDateString('fr-FR', {year: 'numeric', month: '2-digit', day: '2-digit'})"
                :invalid-feedback="form.startDate.invalidFeedback"
                :state="form.startDate.state"
              >
                <vc-date-picker
                  ref="startDateCal"
                  v-model="form.startDate.value"
                  mode="date"
                  locale="fr"
                  color="orange"
                  :popover="{ visibility: 'focus' }"
                  :minute-increment="5"
                  :first-day-of-week="2"
                  :modelConfig="modelConfig"
                  :attributes="datePickerAttributes"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="border px-2 py-1 rounded start-date-datepicker"
                      :class="{'is-invalid': form.startDate.state === false}"
                      :value="inputValue"
                      v-on="inputEvents"
                      placeholder="Date de début"
                    />
                  </template>
                </vc-date-picker>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="quoteDayNumber-input"
                label="Nombre de jours compris dans le devis *"
                label-for="quoteDayNumber-input"
                class="bold-label"
                :invalid-feedback="form.quoteDayNumber.invalidFeedback"
                :state="form.quoteDayNumber.state"
              >
                <b-form-input
                  id="quoteDayNumber-input"
                  v-model="form.quoteDayNumber.value"
                  type="number"
                  :state="form.quoteDayNumber.state"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Estimation de sortie"
                label-for="presumedEndDateCal"
                class="bold-label"
                :description="'Format : ' + new Date().toLocaleDateString('fr-FR', {year: 'numeric', month: '2-digit', day: '2-digit'})"
                :invalid-feedback="form.startDate.invalidFeedback"
                :state="form.startDate.state"
              >
                <vc-date-picker
                  ref="presumedEndDateCal"
                  v-model="form.presumedEndDate.value"
                  mode="date"
                  locale="fr"
                  color="orange"
                  :popover="{ visibility: 'focus' }"
                  :first-day-of-week="2"
                  :modelConfig="modelConfig"
                  :attributes="datePickerAttributes"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="border px-2 py-1 rounded start-date-datepicker mt-2"
                      :class="{'is-invalid': form.presumedEndDate.state === false}"
                      :value="inputValue"
                      v-on="inputEvents"
                      placeholder="Date de sortie estimée"
                    />
                  </template>
                </vc-date-picker>
              </b-form-group>
            </b-col>
            <b-col>

            </b-col>
          </b-row>

          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="secondary" :disabled="sendButtonDisabled">Valider</b-button>
          </div>
        </b-form>

      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import AutoCompleteInput from "../../components/AutoCompleteInput";

export default {

  name: 'HospitalizationEdit',

  components: {
    BackArrow,
    AutoCompleteInput
  },

  data() {
    return {

      hospitalizationId: this.$route.params.hospitalizationId,
      hospitalization: null,
      previousRoute: null,

      animals: [],
      animalSelectInvalid: false,
      sendButtonDisabled: false,

      modelConfig: {
        type: 'number',
        timeAdjust: '10:00:00'
      },

      datePickerAttributes: [
        {
          key: 'today',
          highlight: {
            color : "orange",
            fillMode: 'outline',
          },
          dates: new Date(),
        },
      ],

      form: {
        animal: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        startDate: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        presumedEndDate: {
          state: null,
          invalidFeedback: null,
          value: null,
        },
        goal: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        quoteDayNumber: {
          state: null,
          invalidFeedback: null,
          value: null
        },
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  beforeRouteEnter(to, from, next) {
    // Si on trouve l'info, retour à la page précédente. Sinon, retour à l'index.
    const previousRoute = (from && from.path !== '/') ? from.path : "/"
    next(vm => vm.previousRoute = previousRoute)
  },

  methods: {

    fetchData() {
      this.fetchHospitalization()
      this.fetchAnimals()
    },

    fetchHospitalization() {
      api
        .get(`/hospitalization/${this.hospitalizationId}`)
        .then(response => {
          this.hospitalization = response.data
          this.setInitialValues()
        })
    },

    fetchAnimals() {
      api
        .get(`/animal`)
        .then(response => {
          this.animals = [{ value: null, text: 'Sélectionner un animal', disabled: true }]
          response.data.map(animal => {
            this.animals.push({value: animal.id, text:  `${animal.name} (${animal.user.name})`})
          })
        })
    },

    setInitialValues() {
      this.form.animal.value = this.hospitalization.animal.id
      this.form.startDate.value = this.hospitalization.startDate
      this.form.presumedEndDate.value = this.hospitalization.presumedEndDate
      this.form.goal.value = this.hospitalization.goal
      this.form.quoteDayNumber.value = this.hospitalization.quoteDayNumber
    },

    onSubmit() {
      if(this.form.animal.value === null){
        this.animalSelectInvalid = true
        return
      }
      this.sendButtonDisabled = true

      let data = new FormData()
      data.append('animalId', this.form.animal.value)
      data.append('startDate', this.form.startDate.value)
      data.append('presumedEndDate', this.form.presumedEndDate.value)
      data.append('goal', this.form.goal.value)
      data.append('quoteDayNumber', this.form.quoteDayNumber.value)


      api({
        method: 'POST',
        url: `/hospitalization/${this.hospitalization.id}`,
        data: data
      })
        .then((response) => {
          this.$router.push({
            name: 'HospitalizationShow',
            params: {
              hospitalizationId: this.hospitalization.id
            }
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.name.value)
            })
          })
        })
        .catch((error) => {
          this.sendButtonDisabled = false
          if (error.response.status === 418) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]["state"] = false
            this.form[invalidField]["invalidFeedback"] = error.response.data.message
          }
        });
    },

    successToast(hospitalizationName) {
      this.$bvToast.toast(`Hospitalisation modifiée`, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>
.start-date-datepicker {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--main-text-color);
  height: calc(1.5em + 0.75rem + 2px);
  border: 1px solid var(--neutral-300) !important;
  border-radius: 0.25rem;
  width: 100%;
}
.start-date-datepicker.is-invalid {
  border: solid var(--main-red) 1px !important;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23767676' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat, var(--main-white) url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F4464F' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23F4464F' stroke='none'/%3e%3c/svg%3e") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat
}
</style>



// WEBPACK FOOTER //
// src/views/hospitalization/HospitalizationEdit.vue